var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',{ref:"table",staticClass:"table"},[_c('thead',[_c('tr',_vm._l((_vm.headers),function(tableHeader,i){return _c('th',{key:i,class:[
            {
              'head--spacing': _vm.headSpacing
            }
          ]},[_vm._v("\n          "+_vm._s(tableHeader.label)+"\n        ")])}),0)]),_c('tbody',[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }